import React from "react";
import { Row, Col } from 'react-bootstrap';
import { Link } from "react-router-dom";

import './IconLink.scss';

export interface IconLinkProps {
    iconClass : string;
    iconDescription: string;
    iconLink: string;
    iconComponent: JSX.Element;
}

export const IconLink = ({ iconClass, iconLink, iconDescription, iconComponent }: IconLinkProps ) => {

    const containerClassName = `icon-link ${iconClass}`

    return (
        <Link to={iconLink}>
            <Row data-testid="icon-link" className={containerClassName}>
                <Col xs={3} md={4} className="icon-container">
                    {iconComponent}
                </Col>
                <Col xs={9} md={8}>
                    <div className="description">{iconDescription}</div>
                </Col>
            </Row>
        </Link>
    );

};